// extracted by mini-css-extract-plugin
export default {"loading":"filters_tab-module___loading___c875a24f","filtersGroupContainer":"filters_tab-module___filtersGroupContainer___a4ae5edf"};